import { Box, Button, Stack, Typography, Grid } from '@mui/material'
import Graph from 'react-graph-vis' 
import CloseIcon from '@mui/icons-material/Close'
import ArtistGraphMainCollabs from './ArtistGraphMainCollabs'
import ArtistGraphSecondaryCollabs from './ArtistGraphSecondaryCollabs'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import FavoriteIcon from '@mui/icons-material/Favorite'
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import TrackRow from '../../track/TrackRow'

const ArtistGraph = ({id, collabs, graphDatas, events, setNetwork, selectedCollab, handleCloseCollab, loaded}) => {
    const currentArtist = selectedCollab ? [...selectedCollab.roles[0].tracks[0].main_artists, ...selectedCollab.roles[0].tracks[0].featured_artists, ...selectedCollab.roles[0].tracks[0].producers].filter(artist => artist._id === id)[0] : null
    const options = {
        autoResize: true,
        height: '100%',
        width: '100%',
        locale: 'fr',
        clickToUse: true,
        layout: {
            hierarchical: false,
            improvedLayout: true,
            clusterThreshold: 300
        },
        interaction:{
            hover: true,
        },
        physics: {
            enabled: true,
            stabilization: {
                enabled: true,
                fit: true,
                updateInterval: 50,
                iterations: 500
            },
            // repulsion: {
            //     centralGravity: 0.1,
            //     springLength: 150,
            //     springConstant: 0.05,
            //     nodeDistance: 200,
            //     damping: 0.09
            // },
            barnesHut: {
                theta: 0.5,
                gravitationalConstant: -2000,
                centralGravity: 0.3,
                springLength: 95,
                springConstant: 0.04,
                damping: 0.09,
                avoidOverlap: 0
            },
            maxVelocity: 30, //Def. val 50
            minVelocity: 4, //Def. val 0.1
            solver: 'barnesHut',
            adaptiveTimestep: true,
        },
        edges: {
            smooth: true,
            arrowStrikethrough: false,
            color: {
                color: '#ffffff'
            }
        },
        nodes: {
            physics: true,
            font: {
                color: '#ffffff',
                face: 'Montserrat'
            }
        },
        groups: {
            useDefaultGroups: true,
            producer: {color:{background:'red'}, borderWidth:3},
            interpretor: {color:{background:'blue'}, borderWidth:3},
            featured: {color:{background:'green'}, borderWidth:3},
        }
    }


    return (
        <Box sx={{overflow: 'hidden', height: '100%', position: 'relative'}}>
            <Grid id={id} size={12} sx={{overflow: 'hidden', height: '100%', padding: '0', margin: '0', borderRadius: '16px'}}>
                <Graph
                    graph={{
                        nodes: graphDatas.nodes, // graphDatas.nodes.slice(0, 50),
                        edges: graphDatas.edges && graphDatas.edges.length > 0 ? graphDatas.edges.filter(edge => edge.from !== edge.to ) : graphDatas.edges
                    }}
                    options={options}
                    events={events}
                    getNetwork={network => {
                        // console.log('SETTING NETWORK')
                        setNetwork(network)
                        //  if you want access to vis.js network api you can set the state in a parent component using this property
                    }}
                />
            </Grid>
            { selectedCollab 
                ? <Stack direction={'column'} sx={{position:'absolute', top: 0, background: '#17043d', width: '99%', border: '3px solid white', height: '99.6%', borderRadius: '16px', webkitClipPath: 'url(#scoop)', clipPath: 'url(#scoop)' }}>
                    <svg width='0' height='0'>
                        <defs>
                            <clipPath id='scoop' clipPathUnits='objectBoundingBox'>
                            <path d='M0.22,0 A0.14,0.16 0 0,1 0,0.24 
                                     L0,0.8 A0.2,0 0 0,1 0,1
                                     L1,1 A1,1 0 0,1 1,1
                                     L1,0.2 A0.2,1 0 0,1 1,0z'/>
                            </clipPath>
                        </defs>
                    </svg>
                    <Stack sx={{position: 'relative', height: '100%'}}>
                        <Stack direction={'row'} >
                            <Grid size={7} offset={3} sx={{p: 2}}>
                                <Typography sx={{pl: 1, fontSize: '3.8vmin', fontWeight: 700}} >{selectedCollab.artist.artist_name}</Typography>
                                <Typography sx={{pl: 3}} variant='caption'>{selectedCollab.artist.genre_names.join(' / ')}</Typography>
                            </Grid>
                            <Grid size={2} sx={{p: 2, textAlign: 'right'}} >
                                <Button onClick={() => handleCloseCollab()}><CloseIcon sx={{color: '#fff', fontSize: '32pt', p: 0, margin: '0 auto',}}/></Button>
                            </Grid>
                        </Stack>
                        <Stack direction={'row'} >
                            <Grid size={9} offset={3} sx={{pl: 2}}>
                                <Typography sx={{fontSize: '2vmin', fontWeight: 700, mr: 4, display: 'inline', verticalAlign: 'middle'}}><FavoriteIcon sx={{verticalAlign: 'middle', fontSize: '3vmin', ml: 2, mr: 2}} />5.8k</Typography> 
                                <Typography sx={{fontSize: '2vmin', fontWeight: 700, mr: 4, display: 'inline', verticalAlign: 'middle'}}><RemoveRedEyeIcon sx={{verticalAlign: 'middle', fontSize: '3vmin', ml: 2, mr: 2}} />12k</Typography> 
                                <Typography sx={{fontSize: '2vmin', fontWeight: 700, mr: 4, display: 'inline', verticalAlign: 'middle'}}><CalendarMonthIcon sx={{verticalAlign: 'middle', fontSize: '3vmin', ml: 2, mr: 2}} />16</Typography> 
                                <Typography sx={{fontSize: '2vmin', fontWeight: 700, mr: 4, display: 'inline', verticalAlign: 'middle'}}><PlayCircleOutlineIcon sx={{verticalAlign: 'middle', fontSize: '3vmin', ml: 2, mr: 2}} />24.6M</Typography> 
                            </Grid>
                        </Stack>
                        <Stack direction={'row'} sx={{pb: 4, pt: 2}}>
                            <Grid size={7} offset={3} sx={{pl: 2, mt: 4}}>
                                <Box sx={{border: '1px solid white', borderRadius: '16px', p: 2, position: 'relative'}}>
                                    <Typography sx={{position: 'absolute', top: '-15px', background: '#17043d', pl: 2, pr: 2}}>Dernière sortie avec <b><i>{currentArtist.artist_name}</i></b></Typography>
                                    <TrackRow track={[...selectedCollab.roles.map(role => role.tracks)].flat().sort((a, b) => new Date(a.apple_release_date) - new Date(b.apple_release_date))[0]} /> 
                                </Box>
                            </Grid>
                        </Stack>
                        <Grid size={12} sx={{pl: 4, pr: 4, pb: 0, mt: 4, overflow: 'hidden', overflowY: 'scroll', position: 'inherit', bottom: 0, height: '68%'}}>
                            <ArtistGraphMainCollabs roles={selectedCollab.roles} />
                            <ArtistGraphSecondaryCollabs selectedCollab={selectedCollab}/>
                        </Grid>
                    </Stack>
                </Stack> 
                : ''
            }
        </Box>
    )
}

export default ArtistGraph